

// // src/context/AppContext.js
// import React, {
//   createContext,
//   useContext,
//   useState,
//   useEffect,
//   useRef,
//   useCallback,
//   useMemo,
// } from "react";
// import { apiService } from "../services/api";

// const AppContext = createContext();

// export const useApp = () => {
//   const context = useContext(AppContext);
//   if (!context) throw new Error("useApp must be used within AppProvider");
//   return context;
// };

// export const AppProvider = ({ children }) => {
//   // --- basic app state ---
//   const [currentRole, setCurrentRole] = useState(() => localStorage.getItem("currentRole") || null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // global/admin state
//   const [dashboardStats, setDashboardStats] = useState({});
//   const [orders, setOrders] = useState([]);

//   // manager-specific state
//   const [managerOrders, setManagerOrders] = useState([]);
//   const [managerLoading, setManagerLoading] = useState(false);
//   const [managerError, setManagerError] = useState(null);
//   const [managerPageInfo, setManagerPageInfo] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 });

//   const [users, setUsers] = useState([]);
//   const [pumps, setPumps] = useState([]);
//   const [agentReceivables, setAgentReceivables] = useState([]);
//   const [managerDailyRecords, setManagerDailyRecords] = useState({});

//   const [settings, setSettings] = useState({
//     commission: 5,
//     convenience_fee: 5,
//     allowed_loyalty_points: 5,
//     cashback_value: 5,
//     // optional fallback conversion rate used by UI if server doesn't provide one
//     pointsToCurrencyRate: 1,
//   });

//   // current authenticated user (from /auth/profile)
//   const [currentUser, setCurrentUser] = useState(null);

//   // NEW: agent dashboard stats (from GET /admin/user-listing/agent-dashboard-stats)
//   // shape expected: { total_earnings: number, loyal_points_available: number, referred_count: number }
//   const [agentDashboardStats, setAgentDashboardStats] = useState(null);

//   // NEW: agent referred customers
//   // shape: { agent_referral_code: string|null, data: [] }
//   const [agentReferredCustomers, setAgentReferredCustomers] = useState({
//     agent_referral_code: null,
//     data: [],
//   });
//   const [agentReferredLoading, setAgentReferredLoading] = useState(false);
//   const [agentReferredError, setAgentReferredError] = useState(null);

//   // NEW: agent points & redemptions
//   const [agentPointsData, setAgentPointsData] = useState({ points_value: 0, loyal_points_available: 0 });
//   const [agentPointsLoading, setAgentPointsLoading] = useState(false);
//   const [agentPointsError, setAgentPointsError] = useState(null);

//   // NEW: manager sales aggregates
//   const [managerSalesData, setManagerSalesData] = useState(null);
//   const [managerSalesLoading, setManagerSalesLoading] = useState(false);
//   const [managerSalesError, setManagerSalesError] = useState(null);

//   // avoid double fetch in StrictMode/dev
//   const didFetchRef = useRef(false);

//   // helper: normalize list shapes returned by backend
//   const normalizeList = (resp) => {
//     if (!resp) return [];
//     if (Array.isArray(resp)) return resp;
//     if (Array.isArray(resp.data?.data)) return resp.data.data;
//     if (Array.isArray(resp.data)) return resp.data;
//     if (Array.isArray(resp.bookings)) return resp.bookings;
//     return [];
//   };

//   // --- fetch auth profile if token present ---
//   const fetchCurrentProfile = useCallback(async () => {
//     try {
//       const resp = await apiService.getProfile();
//       const profile = resp?.data ?? resp ?? {};
//       setCurrentUser(profile);

//       if (profile?.user_type) {
//         setCurrentRole(profile.user_type);
//         localStorage.setItem("currentRole", profile.user_type);
//       }

//       return profile;
//     } catch (err) {
//       console.error("Failed to fetch current profile:", err);
//       throw err;
//     }
//   }, []);

//   // NEW: fetch agent dashboard stats
//   const fetchAgentDashboardStats = useCallback(
//     async (opts = {}) => {
//       try {
//         const resp = await apiService.getAgentDashboardStats(opts);
//         const payload = resp?.data ?? resp ?? {};
//         setAgentDashboardStats(payload);
//         return payload;
//       } catch (err) {
//         console.warn("Failed to fetch agent dashboard stats:", err);
//         throw err;
//       }
//     },
//     []
//   );

//   // NEW: fetch agent referred customers (with optional search)
//   const fetchAgentReferredCustomers = useCallback(
//     async (search = "") => {
//       try {
//         setAgentReferredLoading(true);
//         setAgentReferredError(null);
//         const resp = await apiService.getAgentReferredCustomers(search);
//         const payload = resp ?? {};
//         setAgentReferredCustomers({
//           agent_referral_code: payload.agent_referral_code ?? null,
//           data: Array.isArray(payload.data) ? payload.data : [],
//         });
//         return payload;
//       } catch (err) {
//         console.warn("Failed to fetch agent referred customers:", err);
//         setAgentReferredError(err);
//         throw err;
//       } finally {
//         setAgentReferredLoading(false);
//       }
//     },
//     []
//   );

//   // NEW: fetch agent points & redemptions
//   const fetchAgentPointsAndRedemptions = useCallback(
//     async (opts = {}) => {
//       try {
//         setAgentPointsLoading(true);
//         setAgentPointsError(null);
//         const resp = await apiService.getAgentPointsAndRedemptions(opts);
//         const payload = resp ?? {};
//         setAgentPointsData({
//           points_value: Number(payload.points_value ?? 0),
//           loyal_points_available: Number(payload.loyal_points_available ?? 0),
//         });
//         return payload;
//       } catch (err) {
//         console.warn("Failed to fetch agent points & redemptions:", err);
//         setAgentPointsError(err);
//         throw err;
//       } finally {
//         setAgentPointsLoading(false);
//       }
//     },
//     []
//   );

//   // NEW: addRedemptionRequest (stub). Replace with real API call when backend exists.
//   const addRedemptionRequest = useCallback(
//     async (payload) => {
//       // payload: { amount, points, remarks }
//       // TODO: replace with a real POST /agent/redemptions endpoint when available.
//       console.info("addRedemptionRequest stub called", payload);

//       // simulate a small delay so UI shows activity
//       await new Promise((res) => setTimeout(res, 300));

//       // Optionally update local state optimistically
//       setAgentPointsData((prev) => {
//         const newPoints = Math.max(0, (prev.loyal_points_available ?? 0) - (payload.points ?? 0));
//         const newPointsValue = newPoints * (settings.pointsToCurrencyRate ?? 0);
//         return {
//           points_value: newPointsValue,
//           loyal_points_available: newPoints,
//         };
//       });

//       return { success: true };
//     },
//     [settings]
//   );

//   // NEW: fetch manager sales aggregates
//   const fetchManagerSalesRecords = useCallback(
//     async (opts = {}) => {
//       try {
//         setManagerSalesLoading(true);
//         setManagerSalesError(null);

//         // If backend expects manager id param, include it automatically if currentUser exists:
//         const params = { ...(opts.params || {}) };
//         if (!params.managerId && currentUser && (currentUser.user_type === "manager" || currentUser.role === "manager")) {
//           params.managerId = currentUser._id ?? currentUser.id;
//         }

//         const resp = await apiService.getManagerSalesRecords({ params });
//         const payload = resp ?? {};
//         setManagerSalesData({
//           totalOrders: Number(payload.totalOrders ?? payload.total_orders ?? 0),
//           totalVolume: Number(payload.totalVolume ?? payload.total_volume ?? 0),
//           totalEarnings: Number(payload.totalEarnings ?? payload.total_earnings ?? 0),
//           netPayable: Number(payload.netPayable ?? payload.net_payable ?? 0),
//         });
//         return payload;
//       } catch (err) {
//         console.warn("Failed to fetch manager sales records:", err);
//         setManagerSalesError(err);
//         throw err;
//       } finally {
//         setManagerSalesLoading(false);
//       }
//     },
//     [currentUser]
//   );

//   // ----- START: Initialization effect (single-run, direct apiService calls) -----
//   useEffect(() => {
//     let mounted = true;
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       setLoading(false);
//       return;
//     }

//     (async () => {
//       try {
//         setLoading(true);

//         // call profile directly (avoid depending on fetchCurrentProfile identity)
//         const profileResp = await apiService.getProfile();
//         if (!mounted) return;
//         const profile = profileResp?.data ?? profileResp ?? {};
//         setCurrentUser((prev) => {
//           // avoid unnecessary re-renders when profile is identical by shallow compare
//           if (prev && profile && prev._id === profile._id && prev.updatedAt === profile.updatedAt) {
//             return prev;
//           }
//           return profile;
//         });

//         if (profile?.user_type) {
//           setCurrentRole(profile.user_type);
//           localStorage.setItem("currentRole", profile.user_type);
//         }

//         // admin-only bootstrapping (respect didFetchRef)
//         const role = localStorage.getItem("currentRole") || profile?.user_type;
//         if (!didFetchRef.current && token && role === "admin") {
//           didFetchRef.current = true;
//           try {
//             const dashResp = await apiService.getDashBoardStats();
//             if (mounted) setDashboardStats(dashResp ?? {});
//           } catch (err) {
//             console.warn(err);
//           }
//           try {
//             const ordersResp = await apiService.getOrders();
//             if (mounted) setOrders(normalizeList(ordersResp));
//           } catch (err) {
//             console.warn(err);
//           }
//           try {
//             const usersResp = await apiService.getUsers();
//             if (mounted) setUsers(usersResp?.data?.data ?? usersResp?.data ?? usersResp ?? []);
//           } catch (err) {
//             console.warn(err);
//           }
//           try {
//             const pumpsResp = await apiService.getPumps();
//             if (mounted) setPumps(pumpsResp?.data ?? pumpsResp ?? []);
//           } catch (err) {
//             console.warn(err);
//           }
//           try {
//             const agentReceivablesResp = await apiService.getAgentReceivableAmounts();
//             if (mounted) setAgentReceivables(agentReceivablesResp?.data ?? agentReceivablesResp ?? []);
//           } catch (err) {
//             console.warn(err);
//           }
//         }

//         // agent-only / always-fetch items: try but ignore errors
//         try {
//           if (mounted) await fetchAgentDashboardStats();
//         } catch (e) {
//           /* ignore */
//         }
//         try {
//           if (mounted) await fetchAgentReferredCustomers();
//         } catch (e) {
//           /* ignore */
//         }
//         try {
//           if (mounted) await fetchAgentPointsAndRedemptions();
//         } catch (e) {
//           /* ignore */
//         }
//         // fetch manager sales aggregates (server may derive manager from token)
//         try {
//           if (mounted) await fetchManagerSalesRecords();
//         } catch (e) {
//           /* ignore */
//         }
//       } catch (err) {
//         if (mounted) setError(err);
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();

//     return () => {
//       mounted = false;
//     };
//     // run only once on mount
//   }, []); // <<-- intentionally empty
//   // ----- END: Initialization effect -----

//   // --- Manager orders fetch (token-based server lookup) ---
//   const fetchManagerOrders = useCallback(
//     async ({ page = 1, limit = 20, signal } = {}) => {
//       setManagerLoading(true);
//       setManagerError(null);
//       try {
//         const config = { params: { page, limit } };
//         if (signal) config.signal = signal;
//         const resp = await apiService.getManagerOrders(config);
//         const arr = normalizeList(resp);
//         const meta = resp?.data?.meta ?? resp?.meta ?? resp?.pagination ?? {};
//         setManagerPageInfo((prev) => ({
//           page: meta.page ?? page,
//           limit: meta.limit ?? limit,
//           total: meta.total ?? prev.total ?? 0,
//           totalPages: meta.totalPages ?? meta.total_pages ?? prev.totalPages ?? 0,
//         }));
//         setManagerOrders(arr);
//         return arr;
//       } catch (err) {
//         if (err?.name === "AbortError") return [];
//         setManagerError(err);
//         console.error("Failed to fetch manager orders:", err);
//         throw err;
//       } finally {
//         setManagerLoading(false);
//       }
//     },
//     []
//   );

//   const fetchManagerOrdersWithAbort = useCallback(
//     (opts = {}) => {
//       const controller = new AbortController();
//       const promise = fetchManagerOrders({ ...opts, signal: controller.signal });
//       return { promise, controller };
//     },
//     [fetchManagerOrders]
//   );

//   // --- profile update for current user (manager/agent updating their own profile) ---
//   const updateProfile = useCallback(
//     async (payload) => {
//       try {
//         const resp = await apiService.updateProfile(payload);
//         const updatedProfile = resp?.data ?? resp ?? {};

//         setCurrentUser((prev) => ({ ...prev, ...updatedProfile }));

//         if (updatedProfile?.user_type) {
//           setCurrentRole(updatedProfile.user_type);
//           localStorage.setItem("currentRole", updatedProfile.user_type);
//         }

//         setUsers((prev) => prev.map((u) => (u._id === updatedProfile._id ? { ...u, ...updatedProfile } : u)));

//         return updatedProfile;
//       } catch (err) {
//         console.error("Failed to update profile:", err);
//         throw err;
//       }
//     },
//     []
//   );

//   // updateUser remains for admin updating other users (keeps backward compat)
//   const updateUser = useCallback(
//     async (userId, updates) => {
//       try {
//         const resp = await apiService.updateUserAdmin(userId, updates);
//         const updated = resp?.data ?? resp ?? {};
//         setUsers((prev) => prev.map((u) => (u._id === userId ? { ...u, ...updates, ...updated } : u)));
//         // if currentUser is the same user, sync it
//         if (currentUser?._id === userId) {
//           setCurrentUser((prev) => ({ ...prev, ...updates, ...updated }));
//         }
//         return updated;
//       } catch (err) {
//         console.error("Failed to update user (admin):", err);
//         throw err;
//       }
//     },
//     [currentUser]
//   );

//   // --- other helpers (orders update) ---
//   const updateOrder = useCallback(
//     async (orderId, updates) => {
//       try {
//         const resp = await apiService.updateOrder(orderId, updates);
//         const updated = resp?.data ?? resp ?? null;
//         setOrders((prev) =>
//           prev.map((o) =>
//             String(o._id ?? o.id) === String(orderId) ? (updated ? { ...o, ...updated } : { ...o, ...updates }) : o
//           )
//         );
//         setManagerOrders((prev) =>
//           prev.map((o) =>
//             String(o._id ?? o.id) === String(orderId) ? (updated ? { ...o, ...updated } : { ...o, ...updates }) : o
//           )
//         );
//         return updated;
//       } catch (err) {
//         console.error("Failed to update order:", err);
//         throw err;
//       }
//     },
//     []
//   );

//   const fetchPumps = useCallback(async () => {
//     try {
//       const pumpsResponse = await apiService.getPumps();
//       setPumps(pumpsResponse?.data ?? pumpsResponse ?? []);
//     } catch (err) {
//       console.error("Failed to fetch pumps:", err);
//       throw err;
//     }
//   }, []);

//   const updateSettings = useCallback((newSettings) => {
//     setSettings((prev) => ({ ...prev, ...newSettings }));
//   }, []);

//   // Memoize context value
//   const value = useMemo(
//     () => ({
//       dashboardStats,
//       setDashboardStats,

//       loading,
//       error,

//       currentRole,
//       setCurrentRole,

//       managerOrders,
//       managerLoading,
//       managerError,
//       managerPageInfo,
//       setManagerOrders,

//       currentUser,
//       setCurrentUser,
//       fetchCurrentProfile,
//       updateProfile,

//       orders,
//       setOrders,

//       pumps,
//       setPumps,
//       fetchPumps,

//       users,
//       setUsers,
//       updateUser,

//       agentReceivables,
//       setAgentReceivables,

//       managerDailyRecords,
//       setManagerDailyRecords,

//       fetchManagerOrders,
//       fetchManagerOrdersWithAbort,
//       updateOrder,

//       settings,
//       updateSettings,

//       // NEW exports
//       agentDashboardStats,
//       fetchAgentDashboardStats,

//       agentReferredCustomers,
//       agentReferredLoading,
//       agentReferredError,
//       fetchAgentReferredCustomers,

//       agentPointsData,
//       agentPointsLoading,
//       agentPointsError,
//       fetchAgentPointsAndRedemptions,
//       addRedemptionRequest,

//       managerSalesData,
//       managerSalesLoading,
//       managerSalesError,
//       fetchManagerSalesRecords,
//     }),
//     [
//       dashboardStats,
//       loading,
//       error,
//       currentRole,
//       currentUser,
//       orders,
//       pumps,
//       users,
//       agentReceivables,
//       managerDailyRecords,
//       managerOrders,
//       managerLoading,
//       managerError,
//       managerPageInfo,
//       fetchPumps,
//       fetchManagerOrders,
//       fetchManagerOrdersWithAbort,
//       updateOrder,
//       settings,
//       agentDashboardStats,
//       fetchAgentDashboardStats,
//       agentReferredCustomers,
//       agentReferredLoading,
//       agentReferredError,
//       fetchAgentReferredCustomers,
//       agentPointsData,
//       agentPointsLoading,
//       agentPointsError,
//       fetchAgentPointsAndRedemptions,
//       addRedemptionRequest,
//       managerSalesData,
//       managerSalesLoading,
//       managerSalesError,
//       fetchManagerSalesRecords,
//     ]
//   );

//   return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
// };

// export default AppProvider;



// src/context/AppContext.js
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { apiService } from "../services/api";

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) throw new Error("useApp must be used within AppProvider");
  return context;
};

export const AppProvider = ({ children }) => {
  // --- basic app state ---
  const [currentRole, setCurrentRole] = useState(() => localStorage.getItem("currentRole") || null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // global/admin state
  const [dashboardStats, setDashboardStats] = useState({});
  const [orders, setOrders] = useState([]);

  // manager-specific state
  const [managerOrders, setManagerOrders] = useState([]);
  const [managerLoading, setManagerLoading] = useState(false);
  const [managerError, setManagerError] = useState(null);
  const [managerPageInfo, setManagerPageInfo] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
  });

  const [users, setUsers] = useState([]);
  const [pumps, setPumps] = useState([]);
  const [agentReceivables, setAgentReceivables] = useState([]);
  const [managerDailyRecords, setManagerDailyRecords] = useState({});

  const [settings, setSettings] = useState({
    commission: 5,
    convenience_fee: 5,
    allowed_loyalty_points: 5,
    cashback_value: 5,
    // optional fallback conversion rate used by UI if server doesn't provide one
    pointsToCurrencyRate: 1,
  });

  // current authenticated user (from /auth/profile)
  const [currentUser, setCurrentUser] = useState(null);

  // NEW: agent dashboard stats (from GET /admin/user-listing/agent-dashboard-stats)
  // shape expected: { total_earnings: number, loyal_points_available: number, referred_count: number }
  const [agentDashboardStats, setAgentDashboardStats] = useState(null);

  // NEW: agent referred customers
  // shape: { agent_referral_code: string|null, data: [] }
  const [agentReferredCustomers, setAgentReferredCustomers] = useState({
    agent_referral_code: null,
    data: [],
  });
  const [agentReferredLoading, setAgentReferredLoading] = useState(false);
  const [agentReferredError, setAgentReferredError] = useState(null);

  // NEW: agent points & redemptions
  const [agentPointsData, setAgentPointsData] = useState({
    points_value: 0,
    loyal_points_available: 0,
  });
  const [agentPointsLoading, setAgentPointsLoading] = useState(false);
  const [agentPointsError, setAgentPointsError] = useState(null);

  // NEW: manager sales aggregates
  const [managerSalesData, setManagerSalesData] = useState(null);
  const [managerSalesLoading, setManagerSalesLoading] = useState(false);
  const [managerSalesError, setManagerSalesError] = useState(false);

  // avoid double fetch in StrictMode/dev
  const didFetchRef = useRef(false);

  // helper: normalize list shapes returned by backend
  const normalizeList = (resp) => {
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;
    if (Array.isArray(resp.data?.data)) return resp.data.data;
    if (Array.isArray(resp.data)) return resp.data;
    if (Array.isArray(resp.bookings)) return resp.bookings;
    return [];
  };

  // --- fetch auth profile if token present ---
  const fetchCurrentProfile = useCallback(async () => {
    try {
      const resp = await apiService.getProfile();
      const profile = resp?.data ?? resp ?? {};
      setCurrentUser(profile);

      if (profile?.user_type) {
        setCurrentRole(profile.user_type);
        localStorage.setItem("currentRole", profile.user_type);
      }

      return profile;
    } catch (err) {
      console.error("Failed to fetch current profile:", err);
      throw err;
    }
  }, []);

  // NEW: fetch agent dashboard stats
  const fetchAgentDashboardStats = useCallback(async (opts = {}) => {
    try {
      const resp = await apiService.getAgentDashboardStats(opts);
      const payload = resp?.data ?? resp ?? {};
      setAgentDashboardStats(payload);
      return payload;
    } catch (err) {
      console.warn("Failed to fetch agent dashboard stats:", err);
      throw err;
    }
  }, []);

  // NEW: fetch agent referred customers (with optional search)
  const fetchAgentReferredCustomers = useCallback(async (search = "") => {
    try {
      setAgentReferredLoading(true);
      setAgentReferredError(null);
      const resp = await apiService.getAgentReferredCustomers(search);
      const payload = resp ?? {};
      setAgentReferredCustomers({
        agent_referral_code: payload.agent_referral_code ?? null,
        data: Array.isArray(payload.data) ? payload.data : [],
      });
      return payload;
    } catch (err) {
      console.warn("Failed to fetch agent referred customers:", err);
      setAgentReferredError(err);
      throw err;
    } finally {
      setAgentReferredLoading(false);
    }
  }, []);

  // NEW: fetch agent points & redemptions
  const fetchAgentPointsAndRedemptions = useCallback(async (opts = {}) => {
    try {
      setAgentPointsLoading(true);
      setAgentPointsError(null);
      const resp = await apiService.getAgentPointsAndRedemptions(opts);
      const payload = resp ?? {};
      setAgentPointsData({
        points_value: Number(payload.points_value ?? 0),
        loyal_points_available: Number(payload.loyal_points_available ?? 0),
      });
      return payload;
    } catch (err) {
      console.warn("Failed to fetch agent points & redemptions:", err);
      setAgentPointsError(err);
      throw err;
    } finally {
      setAgentPointsLoading(false);
    }
  }, []);

  // NEW: addRedemptionRequest (stub). Replace with real API call when backend exists.
  const addRedemptionRequest = useCallback(
    async (payload) => {
      // payload: { amount, points, remarks }
      console.info("addRedemptionRequest stub called", payload);

      // simulate a small delay so UI shows activity
      await new Promise((res) => setTimeout(res, 300));

      // Optionally update local state optimistically
      setAgentPointsData((prev) => {
        const newPoints = Math.max(0, (prev.loyal_points_available ?? 0) - (payload.points ?? 0));
        const newPointsValue = newPoints * (settings.pointsToCurrencyRate ?? 0);
        return {
          points_value: newPointsValue,
          loyal_points_available: newPoints,
        };
      });

      return { success: true };
    },
    [settings]
  );

  // NEW: fetch manager sales aggregates
  const fetchManagerSalesRecords = useCallback(
    async (opts = {}) => {
      try {
        setManagerSalesLoading(true);
        setManagerSalesError(null);

        // If backend expects manager id param, include it automatically if currentUser exists:
        const params = { ...(opts.params || {}) };
        if (
          !params.managerId &&
          currentUser &&
          (currentUser.user_type === "manager" || currentUser.role === "manager")
        ) {
          params.managerId = currentUser._id ?? currentUser.id;
        }

        const resp = await apiService.getManagerSalesRecords({ params });
        const payload = resp ?? {};
        setManagerSalesData({
          totalOrders: Number(payload.totalOrders ?? payload.total_orders ?? 0),
          totalVolume: Number(payload.totalVolume ?? payload.total_volume ?? 0),
          totalEarnings: Number(payload.totalEarnings ?? payload.total_earnings ?? 0),
          netPayable: Number(payload.netPayable ?? payload.net_payable ?? 0),
        });
        return payload;
      } catch (err) {
        console.warn("Failed to fetch manager sales records:", err);
        setManagerSalesError(err);
        throw err;
      } finally {
        setManagerSalesLoading(false);
      }
    },
    [currentUser]
  );

  // ----- START: Initialization effect (single-run, direct apiService calls) -----
  useEffect(() => {
    let mounted = true;
    const token = localStorage.getItem("authToken");
    if (!token) {
      setLoading(false);
      return;
    }

    (async () => {
      try {
        setLoading(true);

        // call profile directly (avoid depending on fetchCurrentProfile identity)
        const profileResp = await apiService.getProfile();
        if (!mounted) return;
        const profile = profileResp?.data ?? profileResp ?? {};
        setCurrentUser((prev) => {
          // avoid unnecessary re-renders when profile is identical by shallow compare
          if (prev && profile && prev._id === profile._id && prev.updatedAt === profile.updatedAt) {
            return prev;
          }
          return profile;
        });

        if (profile?.user_type) {
          setCurrentRole(profile.user_type);
          localStorage.setItem("currentRole", profile.user_type);
        }

        // admin-only bootstrapping (respect didFetchRef)
        const role = localStorage.getItem("currentRole") || profile?.user_type;
        if (!didFetchRef.current && token && role === "admin") {
          didFetchRef.current = true;
          try {
            const dashResp = await apiService.getDashBoardStats();
            if (mounted) setDashboardStats(dashResp ?? {});
          } catch (err) {
            console.warn(err);
          }
          try {
            const ordersResp = await apiService.getOrders();
            if (mounted) setOrders(normalizeList(ordersResp));
          } catch (err) {
            console.warn(err);
          }
          try {
            const usersResp = await apiService.getUsers();
            if (mounted)
              setUsers(usersResp?.data?.data ?? usersResp?.data ?? usersResp ?? []);
          } catch (err) {
            console.warn(err);
          }
          try {
            const pumpsResp = await apiService.getPumps();
            if (mounted) setPumps(pumpsResp?.data ?? pumpsResp ?? []);
          } catch (err) {
            console.warn(err);
          }
          try {
            const agentReceivablesResp = await apiService.getAgentReceivableAmounts();
            if (mounted)
              setAgentReceivables(
                agentReceivablesResp?.data ?? agentReceivablesResp ?? []
              );
          } catch (err) {
            console.warn(err);
          }
        }

        // agent-only / always-fetch items: try but ignore errors
        try {
          if (mounted) await fetchAgentDashboardStats();
        } catch (e) {
          /* ignore */
        }
        try {
          if (mounted) await fetchAgentReferredCustomers();
        } catch (e) {
          /* ignore */
        }
        try {
          if (mounted) await fetchAgentPointsAndRedemptions();
        } catch (e) {
          /* ignore */
        }
        // fetch manager sales aggregates (server may derive manager from token)
        try {
          if (mounted) await fetchManagerSalesRecords();
        } catch (e) {
          /* ignore */
        }
      } catch (err) {
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
    // run only once on mount
  }, []); // <<-- intentionally empty
  // ----- END: Initialization effect -----

  // --- Manager orders fetch (token-based server lookup) ---
  const fetchManagerOrders = useCallback(
    async ({ page = 1, limit = 20, signal } = {}) => {
      setManagerLoading(true);
      setManagerError(null);
      try {
        const config = { params: { page, limit } };
        if (signal) config.signal = signal;
        const resp = await apiService.getManagerOrders(config);
        const arr = normalizeList(resp);
        const meta = resp?.data?.meta ?? resp?.meta ?? resp?.pagination ?? {};
        setManagerPageInfo((prev) => ({
          page: meta.page ?? page,
          limit: meta.limit ?? limit,
          total: meta.total ?? prev.total ?? 0,
          totalPages: meta.totalPages ?? meta.total_pages ?? prev.totalPages ?? 0,
        }));
        setManagerOrders(arr);
        return arr;
      } catch (err) {
        if (err?.name === "AbortError") return [];
        setManagerError(err);
        console.error("Failed to fetch manager orders:", err);
        throw err;
      } finally {
        setManagerLoading(false);
      }
    },
    []
  );

  const fetchManagerOrdersWithAbort = useCallback(
    (opts = {}) => {
      const controller = new AbortController();
      const promise = fetchManagerOrders({ ...opts, signal: controller.signal });
      return { promise, controller };
    },
    [fetchManagerOrders]
  );

  // --- profile update for current user (manager/agent updating their own profile) ---
  const updateProfile = useCallback(async (payload) => {
    try {
      const resp = await apiService.updateProfile(payload);
      const updatedProfile = resp?.data ?? resp ?? {};

      setCurrentUser((prev) => ({ ...prev, ...updatedProfile }));

      if (updatedProfile?.user_type) {
        setCurrentRole(updatedProfile.user_type);
        localStorage.setItem("currentRole", updatedProfile.user_type);
      }

      setUsers((prev) =>
        prev.map((u) =>
          u._id === updatedProfile._id ? { ...u, ...updatedProfile } : u
        )
      );

      return updatedProfile;
    } catch (err) {
      console.error("Failed to update profile:", err);
      throw err;
    }
  }, []);

  // updateUser remains for admin updating other users (keeps backward compat)
  const updateUser = useCallback(
    async (userId, updates) => {
      try {
        const resp = await apiService.updateUserAdmin(userId, updates);
        const updated = resp?.data ?? resp ?? {};
        setUsers((prev) =>
          prev.map((u) => (u._id === userId ? { ...u, ...updates, ...updated } : u))
        );
        // if currentUser is the same user, sync it
        if (currentUser?._id === userId) {
          setCurrentUser((prev) => ({ ...prev, ...updates, ...updated }));
        }
        return updated;
      } catch (err) {
        console.error("Failed to update user (admin):", err);
        throw err;
      }
    },
    [currentUser]
  );

  // --- other helpers (orders update) ---
  const updateOrder = useCallback(async (orderId, updates) => {
    try {
      const resp = await apiService.updateOrder(orderId, updates);
      const updated = resp?.data ?? resp ?? null;
      setOrders((prev) =>
        prev.map((o) =>
          String(o._id ?? o.id) === String(orderId)
            ? updated
              ? { ...o, ...updated }
              : { ...o, ...updates }
            : o
        )
      );
      setManagerOrders((prev) =>
        prev.map((o) =>
          String(o._id ?? o.id) === String(orderId)
            ? updated
              ? { ...o, ...updated }
              : { ...o, ...updates }
            : o
        )
      );
      return updated;
    } catch (err) {
      console.error("Failed to update order:", err);
      throw err;
    }
  }, []);

  const fetchPumps = useCallback(async () => {
    try {
      const pumpsResponse = await apiService.getPumps();
      setPumps(pumpsResponse?.data ?? pumpsResponse ?? []);
    } catch (err) {
      console.error("Failed to fetch pumps:", err);
      throw err;
    }
  }, []);

  const updateSettings = useCallback((newSettings) => {
    setSettings((prev) => ({ ...prev, ...newSettings }));
  }, []);

  // Memoize context value
  const value = useMemo(
    () => ({
      dashboardStats,
      setDashboardStats,

      loading,
      error,

      currentRole,
      setCurrentRole,

      managerOrders,
      managerLoading,
      managerError,
      managerPageInfo,
      setManagerOrders,

      currentUser,
      setCurrentUser,
      fetchCurrentProfile,
      updateProfile,

      orders,
      setOrders,

      pumps,
      setPumps,
      fetchPumps,

      users,
      setUsers,
      updateUser,

      agentReceivables,
      setAgentReceivables,

      managerDailyRecords,
      setManagerDailyRecords,

      fetchManagerOrders,
      fetchManagerOrdersWithAbort,
      updateOrder,

      settings,
      updateSettings,

      // NEW exports
      agentDashboardStats,
      fetchAgentDashboardStats,

      agentReferredCustomers,
      agentReferredLoading,
      agentReferredError,
      fetchAgentReferredCustomers,

      agentPointsData,
      agentPointsLoading,
      agentPointsError,
      fetchAgentPointsAndRedemptions,
      addRedemptionRequest,

      managerSalesData,
      managerSalesLoading,
      managerSalesError,
      fetchManagerSalesRecords,
    }),
    [
      dashboardStats,
      loading,
      error,
      currentRole,
      currentUser,
      orders,
      pumps,
      users,
      agentReceivables,
      managerDailyRecords,
      managerOrders,
      managerLoading,
      managerError,
      managerPageInfo,
      fetchPumps,
      fetchManagerOrders,
      fetchManagerOrdersWithAbort,
      updateOrder,
      settings,
      agentDashboardStats,
      fetchAgentDashboardStats,
      agentReferredCustomers,
      agentReferredLoading,
      agentReferredError,
      fetchAgentReferredCustomers,
      agentPointsData,
      agentPointsLoading,
      agentPointsError,
      fetchAgentPointsAndRedemptions,
      addRedemptionRequest,
      managerSalesData,
      managerSalesLoading,
      managerSalesError,
      fetchManagerSalesRecords,
    ]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppProvider;
